module.exports = __webpack_public_path__ + "static/assets/40cdadd88211984a2d7c8ea7c11c45cd.png";